import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DOCUMENT_STATUS } from 'src/app/product-capture/model/enums/document-status.enum';
import { DocumentFile } from 'src/app/product-capture/model/interfaces/document-file.interface';
import { DocService } from 'src/app/product-capture/services/doc.service';
import { DcAlertService } from 'src/app/ui-kit/dc-alert/dc-alert.service';
import { DocumentUtils } from '../../documents/document.utils';
import { DocDetails } from '../../documents/documents.model';
import { DOCUMENTS_COMPARE_MODAL_COLUMNS } from './documents-compare-modal-columns.const';

@Component({
  selector: 'app-compare-modal',
  templateUrl: './compare-modal.component.html',
  styleUrls: ['./compare-modal.component.scss'],
})
export class CompareModalComponent implements OnInit {
  document: DocumentFile;
  rows: DocumentFile[] = [];
  columns = DOCUMENTS_COMPARE_MODAL_COLUMNS;
  loading: boolean;
  messages = {
    emptyMessage: 'No documents found.',
    totalMessage: 'Total',
  };
  sortOrder = [
    {
      prop: 'createdOn',
    },
  ];

  constructor(
    public modal: NgbActiveModal,
    private router: Router,
    private docService: DocService,
    private dcAlertService: DcAlertService
  ) { }

  ngOnInit(): void { }

  setDialogProps(props: any): void {
    this.document = props.document;
    this.rows = props.rows.filter(
      (obj) =>
        obj.id !== this.document.id &&
        obj.status !== DOCUMENT_STATUS.NOT_AVAILABLE
    );
  }

  docSelect(e: any): void {
    if (e.type === 'click') {
      this.docService
        .draftableGetArguments(e.row.id, this.document.id)
        .pipe(
          catchError((error: HttpErrorResponse) => {
            this.dcAlertService.showAlert({
              type: 'danger',
              message: `An error occured, please try again`,
            });
            this.loading = false;
            this.modal.close('error');
            console.log(error);

            return throwError(error);
          })
        )
        .subscribe((data) => {
          this.loading = true;
          const docDetails1: DocDetails = DocumentUtils.getDocumentDetails(data[0], e.row);
          const docDetails2: DocDetails = DocumentUtils.getDocumentDetails(data[1], this.document);

          this.docService.draftableGetLink(docDetails1, docDetails2, true).subscribe(
            ({ draftableUrl }) => {
              const base64Url = btoa(draftableUrl);
              const url = this.router.serializeUrl(
                this.router.createUrlTree([
                  'product-capture/diff-pdf',
                  this.docService.getFileName(this.document.fileUrl),
                  base64Url,
                ])
              );
              window.open(url, '_blank');
              this.modal.close('selected');
              this.loading = false;
            },
            (error) => {
              this.dcAlertService.showAlert({
                type: 'danger',
                message: `An error occured, please try again`,
              });
              this.loading = false;
              this.modal.close('error');
              console.log(error);
            }
          );
        });
    }
  }

  cancel(): void {
    this.modal.close('cancel');
  }
}
